import React, { useState, useEffect } from 'react';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import { API } from '../../../API/API';
import PageHeader from '../../../components/PageHeader/PageHeader';

const LanguageReport = (props) => {
    //Data оноох функц
    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);
    //Багана оноох функцы
    const [columns] = useState([{
        name: 'Ажилтны нэр',
        fieldName: 'empfirstname',
        minColSize: 'mid'
    }, {
        name: 'Албан тушаал',
        fieldName: 'positionname',
        minColSize: 'mid'
    }, {
        name: 'Дотоод нэгж',
        fieldName: 'departmentname',
        minColSize: 'mid'
    }, {
        name: 'Гадаад хэл',
        fieldName: 'forlanguagename'
    }, {
        name: 'Уншиж ойлгох',
        fieldName: 'readinglevelname'
    }, {
        name: 'Бичиж орчуулах',
        fieldName: 'writinglevelname'
    }, {
        name: 'Ярьсныг ойлгох',
        fieldName: 'listeninglevelname'
    }, {
        name: 'Өөрөө ярих',
        fieldName: 'speakinglevelname'
    }, {
        name: 'Үзсэн хугацаа /сараар/',
        fieldName: 'studytime'
    }, {
        name: 'Ielts оноо',
        fieldName: 'ieltsscore'
    }, {
        name: 'Toefl оноо',
        fieldName: 'toeflscore'
    }, {
        name: 'Хүйс',
        fieldName: 'empgendername'
    }]);

    //Loading screen-ны функц
    const [loading, setLoading] = useState(false);

    //Дата оноож байгаа функц
    const getData = async () => {
        setLoading(true);
        let tData = [];
        await API.get('/api/humanresource/report/get_emp_forlanguage_report').then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                tData = response.data.retdata;
            }
        });
        setData(tData);
        setOData(tData);
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, []);

    const onSearch = (p_data) => {
        setData(p_data);
    }

    return (
        <div>
            <PageHeader
                title='Хэлний мэдлэг'
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                loading={loading}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default LanguageReport;